/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2022 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {FETCH_PRODUCT_DETAILS_SUCCESS, UPDATE_COPYABLE_STATUS, UPDATE_PRODUCT_STAGE} from "../_actions/etext.publish.actions";

export const INITIAL_STATE = {
    productDetails: []
};

export function productDetailsReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_PRODUCT_DETAILS_SUCCESS:{
            return action.payload;
        }
        case UPDATE_COPYABLE_STATUS:{
            return {...state, courses: {isCopyable: action.payload}};
        }
        case UPDATE_PRODUCT_STAGE:{
            return {...state,  productStage: action.payload};
        }
        
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/product.details.reducer.js